<template>
    <div id="carouselSimple" class="carousel slide" data-bs-ride="carousel" data-bs-interval="false">
        <div class="carousel-indicators">
            <template v-for="(item, index) in items" :key="index">
                <button type="button" data-bs-target="#carouselSimple" :data-bs-slide-to="index" :class="index == 0 ? 'active' : ''" aria-current="true" aria-label="Slide 1"></button>
            </template>
        </div>
        <div class="carousel-inner">
            <template v-for="(item, index) in items" :key="index">
                <div class="carousel-item" :class="index == 0 ? 'active' : '' " :style="`background-image: url(${item.image});`">
                    <div class="carousel-caption d-none d-md-block py-4">
                        <h5>{{item.date}}</h5>
                        <p>{{item.title}}</p>
                    </div>
                </div>
            </template>
        </div>
        <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselSimple"
            data-bs-slide="prev"
        >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselSimple"
            data-bs-slide="next"
        >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
</template>

<script>
export default {
    props:['items'],
    setup() {

    },
}
</script>


<style lang="scss">
.carousel-caption {
    right: unset;
    left: unset;
    width: 100%;
    // background-image: linear-gradient(90deg, rgba(10, 10, 210, 0.7), rgba(0, 0, 0, 0.67));
    background-image: linear-gradient(
            -90deg,
            rgba(189, 189, 189, 0.8),
            rgba(0, 118, 189, 0.8),
            transparent 100%
        );
}
.carousel-item{
    height: 500px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>